import React, { useContext, useEffect, useState } from "react";
import { Button, Icon, Table } from "semantic-ui-react";
import { useToasts } from "react-toast-notifications";
import { AppContext } from "../../../../Context/AppContext";
import { CriticalUnitsSummary } from "../../../../constants";
import "./mdl-critical-summary.css";

const EMPTY_TOTALS = {
  total_criticals: 0,
  ytd_resolved: 0,
  past_week_criticals: 0,
};

const MDL_CRITICAL_SUMMARY = ({ set_mdl_open, schedulerID }) => {
  const { userInfo, appVersion, isAppVersionOutdated } = useContext(AppContext);
  const [user] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState(EMPTY_TOTALS);

  useEffect(() => {
    fetchSummary();
  }, [schedulerID]);

  async function fetchSummary() {
    setLoading(true);
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + user.token,
          entityid: user.uuid,
          appversion: var_app_version,
        },
      };
      const schedulerParam =
        !schedulerID || schedulerID === "all" ? "all" : schedulerID;
      const response = await fetch(
        `${CriticalUnitsSummary}?schedulerID=${encodeURIComponent(
          schedulerParam,
        )}`,
        requestOptions,
      );
      const res = await response.json();
      if (res?.version && res?.version !== var_app_version) {
        set_is_app_version_outdated(true);
      }
      if (res.code === 200) {
        setRows(Array.isArray(res.data) ? res.data : []);
        setTotals(res.totals || EMPTY_TOTALS);
      } else {
        setRows([]);
        setTotals(EMPTY_TOTALS);
        addToast(res.failed || res.message || "Failed to load summary", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (error) {
      console.error("Error fetching critical summary:", error);
      addToast("Failed to load summary", {
        appearance: "error",
        autoDismiss: true,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="modal-header">
        <div className="modal-header-title">Critical Units Summary</div>
        <div
          className="modal-header-close"
          onClick={() => set_mdl_open(false)}
        >
          <Icon name="times circle outline" />
        </div>
      </div>
      <div className="modal-content critical-summary-content">
        <Table celled unstackable className="critical-summary-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="left">Region</Table.HeaderCell>
              <Table.HeaderCell textAlign="right">
                Total Criticals
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right">
                YTD (Resolved)
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right">Past Week</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {loading && (
              <Table.Row>
                <Table.Cell colSpan="4" textAlign="center">
                  Loading summary...
                </Table.Cell>
              </Table.Row>
            )}
            {!loading && rows.length === 0 && (
              <Table.Row>
                <Table.Cell colSpan="4" textAlign="center">
                  No critical unit summary data found
                </Table.Cell>
              </Table.Row>
            )}
            {!loading &&
              rows.map((row) => (
                <Table.Row key={row.region}>
                  <Table.Cell textAlign="left">{row.region}</Table.Cell>
                  <Table.Cell textAlign="right">
                    {row.total_criticals}
                  </Table.Cell>
                  <Table.Cell textAlign="right">{row.ytd_resolved}</Table.Cell>
                  <Table.Cell textAlign="right">
                    {row.past_week_criticals}
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
          {!loading && rows.length > 0 && (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell textAlign="left">Total</Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {totals.total_criticals}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {totals.ytd_resolved}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {totals.past_week_criticals}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          )}
        </Table>
      </div>
      <div className="modal-footer">
        <Button type="button" onClick={() => set_mdl_open(false)}>
          Close
        </Button>
      </div>
    </>
  );
};

export default MDL_CRITICAL_SUMMARY;
